import React from 'react';
import { usePageSeo } from '../Seo/PageSeo';
import '../Common/PlatformInfo.css'

const VenuesInfo = () => {
  usePageSeo({
    title: 'List your venue',
    description:
      'Partner with Occasia to fill quiet hours, take event enquiries online, and grow revenue from your pub, café, or event space.',
    path: '/venues-info'
  });

  const handleListVenueClick = () => {
    window.open('https://tally.so/r/n9gP7E', '_blank');
  };

  return (
    <div className="platform-info-page">
      {/* Grow Revenue Section */}
      <section className="grow-revenue-section">
        <div className="container">
          <div className="content">
            <h1>Turn Your Space Into a Thriving Event Destination</h1>
            <p className="venue-heading-para">
              Partner with Occasia and start generating additional income, sharing your venue with the local community.
            </p>
            <button className="cta-button" onClick={handleListVenueClick}>
              <span>List your venue</span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M7.5 5L12.5 10L7.5 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
          <div className="illustration">
            <svg width="600" height="600" viewBox="0 0 200 200" fill="none">
              {/* Building */}
              <rect x="60" y="80" width="80" height="100" fill="#F5F5DC" stroke="#000" strokeWidth="2"/>
              <rect x="60" y="80" width="80" height="20" fill="#FFF"/>
              {/* Windows */}
              <rect x="70" y="90" width="15" height="15" fill="#046242"/>
              <rect x="95" y="90" width="15" height="15" fill="#046242"/>
              <rect x="120" y="90" width="15" height="15" fill="#046242"/>
              <rect x="70" y="115" width="15" height="15" fill="#046242"/>
              <rect x="95" y="115" width="15" height="15" fill="#046242"/>
              <rect x="120" y="115" width="15" height="15" fill="#046242"/>
              <rect x="70" y="140" width="15" height="15" fill="#046242"/>
              <rect x="95" y="140" width="15" height="15" fill="#046242"/>
              <rect x="120" y="140" width="15" height="15" fill="#046242"/>
              {/* Door */}
              <rect x="95" y="160" width="10" height="20" fill="#F6C531"/>
              {/* Trees */}
              <path d="M40 160L50 120L60 160" stroke="#000" strokeWidth="1" fill="none"/>
              <path d="M140 160L150 120L160 160" stroke="#000" strokeWidth="1" fill="none"/>
              {/* Yellow circles */}
              <circle cx="45" cy="150" r="8" fill="#F6C531"/>
              <circle cx="155" cy="170" r="5" fill="#F6C531"/>
              {/* Green bushes */}
              <circle cx="50" cy="180" r="6" fill="#046242"/>
              <circle cx="150" cy="185" r="4" fill="#046242"/>
            </svg>
          </div>
        </div>
      </section>

      {/* Choose How You Share Section */}
      <section className="choose-share-section">
        <div className="container">
          <div className="content">
            <h2>Choose how you share</h2>
            <p className="intro">We champion <strong>independent venues </strong>— pubs, cafes, coworking spaces — not just the big players.</p>
            <div className="description">
              <p>We prioritise <strong>sustainable earnings </strong>, helping you increase usage of your space without burning out your team.</p>
              <p>We provide a <strong>human touch</strong> with concierge support, making sure you and your guests have a
                smooth experience.</p>
            </div>
            <button className="cta-button" onClick={handleListVenueClick}>
              <span>List your venue</span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M7.5 5L12.5 10L7.5 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
          <div className="photo">
            <div className="photo-container">
              {/*<div className="badge">TOP HOST</div>*/}
              <img src="/venue_owner.jpg" alt="Ben Seidel" className="host-photo"/>
              <p className="caption">Paula Skrinis • Hosting since 2016</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Partner Section */}
      <section className="why-partner-section">
        <div className="container">
          <h1>WHY PARTNER WITH OCCASIA</h1>
          <p className="intro">
            Everyone from professional photographers and yoga teachers, to Fortune 500 companies need places to meet, create, and celebrate. Get your space in front of the most people searching for spaces like yours.
          </p>
          
          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="icon">
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M37.333 42.6666C37.333 47.3866 35.2797 51.6532 31.9997 54.5599C29.173 57.1199 25.4397 58.6666 21.333 58.6666C12.5063 58.6666 5.33301 51.4932 5.33301 42.6666C5.33301 35.3066 10.3463 29.0666 17.1197 27.2266C18.9597 31.8666 22.9063 35.4399 27.7863 36.7732C29.1197 37.1466 30.533 37.3332 31.9997 37.3332C33.4663 37.3332 34.8797 37.1466 36.213 36.7732C36.933 38.5866 37.333 40.5866 37.333 42.6666Z"
                      stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                      d="M48 21.3334C48 23.4134 47.6 25.4134 46.88 27.2267C45.04 31.8667 41.0933 35.44 36.2133 36.7734C34.88 37.1467 33.4667 37.3334 32 37.3334C30.5333 37.3334 29.12 37.1467 27.7867 36.7734C22.9067 35.44 18.96 31.8667 17.12 27.2267C16.4 25.4134 16 23.4134 16 21.3334C16 12.5067 23.1733 5.33337 32 5.33337C40.8267 5.33337 48 12.5067 48 21.3334Z"
                      stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                      d="M58.6667 42.6666C58.6667 51.4932 51.4933 58.6666 42.6667 58.6666C38.56 58.6666 34.8267 57.1199 32 54.5599C35.28 51.6532 37.3333 47.3866 37.3333 42.6666C37.3333 40.5866 36.9333 38.5866 36.2133 36.7732C41.0933 35.4399 45.04 31.8666 46.88 27.2266C53.6533 29.0666 58.6667 35.3066 58.6667 42.6666Z"
                      stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

              </div>
              <h3>More bookings, less admin</h3>
              <p>You don't have to worry about manually answering those enquiries every time</p>
            </div>

            <div className="benefit-item">
              <div className="icon">
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.33398 23.9999V17.3333C5.33398 10.6933 10.694 5.33325 17.334 5.33325H24.0007"
                        stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M40 5.33325H46.6667C53.3067 5.33325 58.6667 10.6933 58.6667 17.3333V23.9999" stroke="white"
                        stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M58.666 42.6667V46.6667C58.666 53.3067 53.306 58.6667 46.666 58.6667H42.666" stroke="white"
                        stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M24.0007 58.6667H17.334C10.694 58.6667 5.33398 53.3067 5.33398 46.6667V40" stroke="white"
                        stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                      d="M45.3327 25.3333V38.6666C45.3327 43.9999 42.666 46.6666 37.3327 46.6666H26.666C21.3327 46.6666 18.666 43.9999 18.666 38.6666V25.3333C18.666 19.9999 21.3327 17.3333 26.666 17.3333H37.3327C42.666 17.3333 45.3327 19.9999 45.3327 25.3333Z"
                      stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M50.6663 32H13.333" stroke="white" stroke-width="3" stroke-linecap="round"
                        stroke-linejoin="round"/>
                </svg>

              </div>
              <h3>List your venue in minutes</h3>
              <p>Simple setup process with professional photography support</p>
            </div>

            <div className="benefit-item">
              <div className="icon">
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M58.6663 44.6399V12.4532C58.6663 9.25319 56.053 6.87985 52.8797 7.14652H52.7197C47.1197 7.62652 38.613 10.4799 33.8663 13.4665L33.413 13.7599C32.6397 14.2399 31.3597 14.2399 30.5863 13.7599L29.9197 13.3599C25.173 10.3999 16.693 7.57319 11.093 7.11985C7.91967 6.85319 5.33301 9.25319 5.33301 12.4265V44.6399C5.33301 47.1999 7.41301 49.5999 9.97301 49.9199L10.7463 50.0265C16.533 50.7999 25.4663 53.7332 30.5863 56.5332L30.693 56.5865C31.413 56.9865 32.5597 56.9865 33.253 56.5865C38.373 53.7599 47.333 50.7999 53.1463 50.0265L54.0263 49.9199C56.5863 49.5999 58.6663 47.1999 58.6663 44.6399Z"
                      stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M32 14.6399V54.6399" stroke="white" stroke-width="3" stroke-linecap="round"
                        stroke-linejoin="round"/>
                  <path d="M20.667 22.6399H14.667" stroke="white" stroke-width="3" stroke-linecap="round"
                        stroke-linejoin="round"/>
                  <path d="M22.667 30.6399H14.667" stroke="white" stroke-width="3" stroke-linecap="round"
                        stroke-linejoin="round"/>
                </svg>

              </div>
              <h3>Reach & collaborate with event organisers</h3>
              <p>Bring more customers to your venue through targeted partnerships.</p>
            </div>

            <div className="benefit-item">
              <div className="icon">
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M55.3337 35.3333C55.3337 48.2133 44.8803 58.6667 32.0003 58.6667C19.1203 58.6667 8.66699 48.2133 8.66699 35.3333C8.66699 22.4533 19.1203 12 32.0003 12C44.8803 12 55.3337 22.4533 55.3337 35.3333Z"
                      stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M32 21.3333V34.6666" stroke="white" stroke-width="3" stroke-linecap="round"
                        stroke-linejoin="round"/>
                  <path d="M24 5.33325H40" stroke="white" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"
                        stroke-linejoin="round"/>
                </svg>

              </div>
              <h3>Manage bookings in one place</h3>
              <p>Increase revenue with smart pricing and real time availability of your space</p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-section">
        <div className="container">
          <div className="left">
            <h2>How it works</h2>
          </div>
          <div className="right">
            <div className="steps">
              <div className="step">
                <div className="number">1</div>
                <div className="content">
                  <h3>Create Your Listing</h3>
                  <p>Upload photos, set your rates, and highlight your amenities.</p>
                </div>
              </div>

              <div className="step">
                <div className="number">2</div>
                <div className="content">
                  <h3>Receive Enquiries</h3>
                  <p>Organisers find your venue and send requests.</p>
                </div>
              </div>

              <div className="step">
                <div className="number">3</div>
                <div className="content">
                  <h3>Confirm & Host</h3>
                  <p>Approve bookings, welcome guests, and earn.</p>
                </div>
              </div>

              <div className="step">
                <div className="number">4</div>
                <div className="content">
                  <h3>Get Insights</h3>
                  <p>Access data to improve occupancy and repeat business.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Bottom Left SVG */}
        <div className="bottom-left-svg">
          <svg xmlns="http://www.w3.org/2000/svg" width="401" height="356" viewBox="0 0 401 356" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M58.5 685C247.656 685 401 531.656 401 342.5C401 153.342 247.656 0 58.5 0C-130.658 0 -284 153.342 -284 342.5C-284 531.656 -130.658 685 58.5 685ZM92.6438 575.513C206.508 558.974 293.969 460.95 293.969 342.5C293.969 224.05 206.508 126.027 92.6438 109.488C82.4887 108.014 77.4094 107.276 72.1589 109.314C67.9461 110.95 63.4971 114.8 61.2708 118.735C58.5 123.638 58.5 129.519 58.5 141.281V543.719C58.5 555.48 58.5 561.361 61.2708 566.266C63.4971 570.201 67.9461 574.051 72.1589 575.688C77.4094 577.726 82.4887 576.986 92.6438 575.513Z" fill="url(#paint0_linear_330_762)"/>
            <defs>
              <linearGradient id="paint0_linear_330_762" x1="58.5" y1="685" x2="58.5" y2="0" gradientUnits="userSpaceOnUse">
                <stop offset="0.552885" stop-color="#F6C531" stop-opacity="0.15"/>
                <stop offset="1" stop-color="#046242" stop-opacity="0.15"/>
              </linearGradient>
            </defs>
          </svg>
        </div>
      </section>
    </div>
  );
};

export default VenuesInfo;
